Object.defineProperty(exports, '__esModule', { value: true });
const prefix = 'fas';
const iconName = 'mobile-screen-button';
const width = 384;
const height = 512;
const aliases = ['mobile-alt'];
const unicode = 'f3cd';
const svgPathData = 'M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
